"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStore = exports.BodyFixedStore = void 0;
var mobx_1 = require("mobx");
var getSingletonStore_1 = require("./getSingletonStore");
var BodyFixedStore = (function () {
    function BodyFixedStore() {
        var _this = this;
        this.top = 0;
        this.isFixed = false;
        this.stopScroll = function () {
            if (_this.isFixed) {
                return;
            }
            _this.isFixed = true;
            _this.top = window.scrollY;
            document.body.style.top = "-" + _this.top + "px";
            document.body.setAttribute("class", "overflowHide");
            document.body.style.overflow = "hidden";
        };
        this.revertScroll = function () {
            document.body.removeAttribute("class");
            document.body.style.top = "0";
            window.scrollTo(0, _this.top);
            _this.top = 0;
            _this.isFixed = false;
            document.body.style.overflow = "scroll";
        };
        window.addEventListener("popstate", function () {
            document.body.removeAttribute("class");
            document.body.style.top = "0";
            _this.top = 0;
            _this.isFixed = false;
        });
    }
    Object.defineProperty(BodyFixedStore.prototype, "scrollTop", {
        get: function () {
            return this.top;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], BodyFixedStore.prototype, "top", void 0);
    __decorate([
        mobx_1.observable
    ], BodyFixedStore.prototype, "isFixed", void 0);
    __decorate([
        mobx_1.computed
    ], BodyFixedStore.prototype, "scrollTop", null);
    __decorate([
        mobx_1.action.bound
    ], BodyFixedStore.prototype, "stopScroll", void 0);
    __decorate([
        mobx_1.action.bound
    ], BodyFixedStore.prototype, "revertScroll", void 0);
    return BodyFixedStore;
}());
exports.BodyFixedStore = BodyFixedStore;
exports.getStore = getSingletonStore_1.default(BodyFixedStore);
